<template>
  <main>
    <static-header />
    <destacate :course="cours"></destacate>
    <get-course />

  </main>
</template>
<script>
import staticHeader from "./static_header.vue";
import getCourse from "./../landig/Profesional_Courses.vue";
import destacate from "./destacate";

import { mapState } from "vuex";

export default {
  metaInfo: {
    title: "Salud E-Learning",
    titleTemplate: "%s - Para todos los profesionales de la salud!",
    content: "Cursos para todos",
    meta: [
      {
        name: "Salud E-Learning",
      },
    ],
    htmlAttrs: {
      lang: "es",
      amp: true,
    },
  },
  name: "Main",
  components: {
    /*formLanding,*/
    getCourse,
    // Editor,
    staticHeader,
    destacate,
  },
  data() {
    return {
      cours: [],
      proyect_id: process.env.VUE_APP_PROYECT_ID,
      spiner: false,
      color: "#9A32D6",
    };
  },
  computed: {
    ...mapState,
  },
  methods: {
    activateInfinite(event) {
      this.cours[4] = event;
    },
    getExternalAllCourses: function() {
      this.spiner = true;
      this.$store
        .dispatch("course/getExternalAllCourses", {
          proyect_id: this.proyect_id,
        })
        .then((response) => {
          this.cours = response;
          this.spiner = false;
        })
        .catch(() => {
          // console.log(error);
        });
    },

  },
  created() {
    this.getExternalAllCourses();
  },
};
</script>
<style>
.rotate {
  -moz-transform: rotate(9deg);
  -webkit-transform: rotate(9deg);
  -o-transform: rotate(9deg);
  -ms-transform: rotate(9deg);
  transform: rotate(9deg);
}

main {
  max-width: 1440px;
  margin: auto;
}

@media (max-width: 990px) {
  .top {
    padding-top: -0px;
    margin-top: -100px;
  }
  .brand {
    width: 90%;
    padding-top: 20px;
  }
}
@media (min-width: 991px) {
  .top {
    padding-top: 300px;
  }
}
</style>
